export default __webpack_public_path__ + "static/media/dataGive.e6cadbf5.png";